(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flush-frog-guide-carousel"] && !Shopify.designMode) return;
  try {
    
  class GuideCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.status = this.querySelector('[data-status]');
      this.index = 0;
      this.paused = false;
      this.interval = Number(this.dataset.interval) || 8000;
      this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
      this.querySelector('[data-toggle]')?.addEventListener('click', () => this.toggle());
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.addEventListener('touchstart', (event) => { this.touchStart = event.changedTouches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (event) => {
        const distance = event.changedTouches[0].clientX - this.touchStart;
        if (Math.abs(distance) > 45) this.show(this.index + (distance < 0 ? 1 : -1), true);
      }, { passive: true });
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(nextIndex, announce) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
      if (announce && this.status) this.status.textContent = this.dots[this.index]?.getAttribute('aria-label') || '';
      this.restart();
    }

    start() {
      if (!this.autoplay || this.paused || this.timer || document.hidden) return;
      this.timer = window.setInterval(() => this.show(this.index + 1, false), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = undefined;
    }

    restart() {
      this.stop();
      this.start();
    }

    toggle() {
      this.paused = !this.paused;
      this.querySelector('[data-pause]')?.toggleAttribute('hidden', this.paused);
      this.querySelector('[data-play]')?.toggleAttribute('hidden', !this.paused);
      this.paused ? this.stop() : this.start();
    }
  }

  if (!customElements.get('guide-carousel')) customElements.define('guide-carousel', GuideCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
